import useHttpProvider from "@/common/hooks/use-http";
import { useEffect, useState } from "react";
import { Promotion } from "../models/giveaway";
import * as GiveawaysService from "../services/giveaways";

function useGiveawayDetails () {
    	const { http } = useHttpProvider();

	const [currentGiveaway, setCurrentGiveaway] = useState<Promotion>();

	const getCurrentPromotion = async () => {
		const queryParams = new URLSearchParams(location.search);
		const id = queryParams.get("id");

		if (id) {
			try {
				const response = await GiveawaysService.getPromotionDetails(
					http,
					parseInt(id)
				);
				setCurrentGiveaway(response);
			} catch {}
		}
	};

	useEffect(() => {
		getCurrentPromotion();
	}, []);

    return { currentGiveaway };
}

export default useGiveawayDetails;